import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import styles from "./styles.module.scss";
import ProgramOption from "../ProgramOption";
import ClinicSvg from "../../../../public/images/clinic-icon.svg";
import CampSvg from "../../../../public/images/camp-icon.svg";
import OperaionSvg from "../../../../public/images/operation36-icon.svg";
import SaveBar from "../../Sessions/SaveBar";
import { useDispatch } from "react-redux";
import {
  resetProgramSettings,
  setDefaultImages,
  startBuild,
} from "../../../actions/scheduling/program";
import { isNull } from "lodash";
import { useTranslation } from "react-i18next";
import { schedulingFetchGet } from "app/utils/request/scheduling/fetch";
import { fetchGet } from "app/utils/request";
import useCurrentFacility from "app/utils/hooks/scheduling/useCurrentFacility";

interface Option {
  title: string;
  label: string;
  subtitle: string;
  image: string;
}

export default function ProgramOptions() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [selected, setSelected] = useState<Option | null>(null);
  const history = useHistory();

  const currentFacility = useCurrentFacility();
  const onSubmit = () => {
    if (selected?.label === "Operation") {
      window.open("https://operation36golf.com/programs/new", "_blank");
      history.push("/programs");
    } else {
      schedulingFetchGet("/default_images").then((response) => {
        dispatch(setDefaultImages(response));
      });
      fetchGet('/account').then((response) => {
        dispatch(
          startBuild({
            page: 1,
            type: selected?.label,
            facilityId: currentFacility.data.id,
            email: response?.email,
            phone: response?.phone,
            timeZone: currentFacility.data.timeZone,
            location: currentFacility.data.address,
            currency: currentFacility.data.currency,
            restrictAdditionalPeople: !currentFacility.data.allowAdditionalPeople,
          })
        );
      });
    }
  };
  const handleSelection = (item) => {
    setSelected(item);
  };
  const programOptions: Option[] = [
    {
      title: t("Drop-In Clinic"),
      label: 'Clinic',
      subtitle: t(
        "Build single or repeating clinics. Each session can have its own sign-up page or appear as part of a series."
      ),
      image: ClinicSvg,
    },
    {
      title: t("Series"),
      label: 'Series',
      subtitle: t(
        "Participants register for all sessions upfront in one transaction. No dropping in and out."
      ),
      image: CampSvg,
    },
    {
      title: t("Operation 36 Program"),
      label: 'Operation',
      subtitle: t(
        "Managed through Operation 36. You'll be redirected."
      ),
      image: OperaionSvg,
    },
  ];

  return (
    <div>
      <div className={`${styles.empty_container} programs-page-container`}>
        <div>
          <div className={styles.container}>
            <p className={`${styles.gray_text}`}>
              {t(
                "Select a program type to get started. Drop-In and Series programs let you manage registration, waitlists, and scheduling directly in CoachNow."
              )}
            </p>
            <div
              className={`${styles.program_options_line_container} ${styles.mt_20}`}
            >
              {programOptions.map((item, index) => {
                return (
                  <ProgramOption
                    key={index}
                    title={item.title}
                    subtitle={item.subtitle}
                    DisplayImage={item.image}
                    selected={selected?.title === item.title}
                    onClick={() => handleSelection(item)}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <SaveBar
        onSubmit={onSubmit}
        showCancel
        onCancel={() => {
          dispatch(resetProgramSettings());
          history.push("/programs");
        }}
        submitDisabled={isNull(selected)}
      />
    </div>
  );
}
